(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-accordion-media"] && !Shopify.designMode) return;
  try {
    
  class FcAccordionMedia extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll("[data-accordion-item]"));
      this.mediaItems = Array.from(this.querySelectorAll("[data-media-item]"));
      this._resizeTimer = null;
      this._isMeasuring = false;
      this._onResizeBound = this._onResize.bind(this);
      this._onClickBound = this._onClick.bind(this);

      this.addEventListener("toggle", this._onToggle, true);
      this.addEventListener("click", this._onClickBound);
      window.addEventListener("resize", this._onResizeBound, { passive: true });
      this._sync();
      requestAnimationFrame(() => {
        this._measureDesktopAccordionHeights();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this._measureDesktopAccordionHeights());
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener("toggle", this._onToggle, true);
      this.removeEventListener("click", this._onClickBound);
      window.removeEventListener("resize", this._onResizeBound);
      clearTimeout(this._resizeTimer);
    }

    // One panel always stays open: clicking the open item's summary would close it,
    // fire a toggle, and force a snap re-open — intercept it instead so nothing moves.
    _onClick(event) {
      const summary = event.target.closest("summary");
      if (!summary) {
        return;
      }

      const item = summary.closest("[data-accordion-item]");
      if (item && this.contains(item) && item.open) {
        event.preventDefault();
      }
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._measureDesktopAccordionHeights(), 150);
    }

    _measureDesktopAccordionHeights() {
      if (!this.items.length) {
        return;
      }

      const desktop = window.matchMedia("(min-width: 1000px)");
      if (!desktop.matches) {
        this.style.removeProperty("--fc-accordion-media-measured-min");
        this.classList.remove("fc-accordion-media--is-measuring");
        return;
      }

      const col = this.querySelector(".fc-accordion-media__items");
      if (!col) {
        return;
      }

      const restore = this.items.find((item) => item.open) || this.items[0];

      // Toggle events fired while force-opening items for measurement must not
      // run the animation/sync logic — flag the pass so _onToggle ignores them.
      this._isMeasuring = true;
      this.classList.add("fc-accordion-media--is-measuring");

      let maxCol = 0;
      for (const item of this.items) {
        for (const other of this.items) {
          other.open = other === item;
        }
        void col.offsetHeight;
        maxCol = Math.max(maxCol, col.scrollHeight);
      }

      // Restore the pre-measurement state explicitly: exactly one item open.
      for (const item of this.items) {
        item.classList.remove("fc-accordion-media__item--closing");
        item.open = item === restore;
      }

      this.classList.remove("fc-accordion-media--is-measuring");
      this._isMeasuring = false;

      this._sync(restore);
      this.style.setProperty("--fc-accordion-media-measured-min", `${Math.ceil(maxCol)}px`);
    }

    _onToggle(event) {
      if (this._isMeasuring) {
        return;
      }

      const item = event.target.closest("[data-accordion-item]");

      if (!item || !this.contains(item)) {
        return;
      }

      if (!item.open) {
        // An item finished closing (end of the closing animation, or a programmatic
        // close). Just make sure aria/media stay in sync with whichever item is open.
        item.classList.remove("fc-accordion-media__item--closing");
        const openItem = this.items.find((accordionItem) => accordionItem.open);
        if (openItem) {
          this._sync(openItem);
        }
        return;
      }

      this._animateOpen(item);
      this._sync(item);
      void this._closeOthersWithAnimation(item);
    }

    // When a <details> gains [open] its panel goes from unrendered straight to
    // grid-template-rows: 1fr, so the CSS transition never runs and the panel
    // snaps open while the closing one animates. Start it at 0fr for one frame,
    // then release to the stylesheet value so open and close glide together.
    _animateOpen(item) {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }

      const panel = item.querySelector(".fc-accordion-media__answer-panel");
      if (!panel) {
        return;
      }

      panel.style.gridTemplateRows = "0fr";
      void panel.offsetHeight;
      requestAnimationFrame(() => {
        panel.style.gridTemplateRows = "";
      });
    }

    _closeOthersWithAnimation(keepItem) {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        for (const otherItem of this.items) {
          if (otherItem !== keepItem) {
            otherItem.classList.remove("fc-accordion-media__item--closing");
            otherItem.open = false;
          }
        }
        return Promise.resolve();
      }

      const toClose = this.items.filter((accordionItem) => accordionItem !== keepItem && accordionItem.open);

      if (!toClose.length) {
        return Promise.resolve();
      }

      return Promise.all(
        toClose.map(
          (other) =>
            new Promise((resolve) => {
              const panel = other.querySelector(".fc-accordion-media__answer-panel");
              if (!panel) {
                other.classList.remove("fc-accordion-media__item--closing");
                other.open = false;
                resolve();
                return;
              }

              let settled = false;
              const settle = () => {
                if (settled) {
                  return;
                }
                settled = true;
                window.clearTimeout(failSafe);
                panel.removeEventListener("transitionend", onEnd);
                other.classList.remove("fc-accordion-media__item--closing");
                other.open = false;
                resolve();
              };

              const onEnd = (ev) => {
                if (ev.target !== panel || ev.propertyName !== "grid-template-rows") {
                  return;
                }
                settle();
              };

              const failSafe = window.setTimeout(settle, 600);
              panel.addEventListener("transitionend", onEnd);

              requestAnimationFrame(() => {
                other.classList.add("fc-accordion-media__item--closing");
              });
            })
        )
      );
    }

    _sync(activeItem = this.items.find((item) => item.open) || this.items[0]) {
      if (!activeItem) {
        return;
      }

      activeItem.open = true;

      for (const item of this.items) {
        item.setAttribute("aria-expanded", item === activeItem ? "true" : "false");
      }

      const activeMedia = this.querySelector(`#${CSS.escape(activeItem.dataset.mediaId)}`);

      for (const mediaItem of this.mediaItems) {
        mediaItem.classList.toggle("is-active", mediaItem === activeMedia);
      }
    }
  }

  if (!customElements.get("fc-accordion-media")) {
    customElements.define("fc-accordion-media", FcAccordionMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specification-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function bindExclusiveAccordion(accordion) {
      if (!accordion || accordion.dataset.specAccordionExclusiveBound) {
        return;
      }

      accordion.dataset.specAccordionExclusiveBound = 'true';

      accordion.addEventListener(
        'toggle',
        (event) => {
          const item = event.target;
          if (item.tagName !== 'DETAILS' || !item.classList.contains('specification-accordion__item')) {
            return;
          }
          if (!item.open) {
            return;
          }

          for (const other of accordion.querySelectorAll('.specification-accordion__item')) {
            if (other !== item) {
              other.open = false;
            }
          }
        },
        true
      );
    }

    function init() {
      for (const accordion of document.querySelectorAll('.specification-accordion')) {
        bindExclusiveAccordion(accordion);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      const accordion = section.querySelector('.specification-accordion');
      if (accordion) {
        delete accordion.dataset.specAccordionExclusiveBound;
      }
      bindExclusiveAccordion(accordion);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
